import React from "react";
import MonStyle from "./Actualites.module.css";
import IllustrationSite from "../../../Images/Actualites/IllustrationSite.png";
import IllustrationConsultationArchive from "../../../Images/Actualites/IllustrationConsultationArchive.png";
import IllustrationNouveauTypeConsultation4 from "../../../Images/Actualites/IllustrationNouveauTypeConsultation4.png";
import IllustrationAllergies from "../../../Images/Actualites/IllustrationAllergies.png";
import IllustrationConsentement from "../../../Images/Actualites/IllustrationConsentement.png";
import BoutonTexte from "../../../Design/Boutons/BoutonTexte";

import IllustrationRdvPersonnalise from "../../../Images/Actualites/Rdv_Personnalise.png";
import IllustrationRdvPersonnaliseEmail from "../../../Images/Actualites/Rdv_Personnalise_Email.png";
import IllustrationCadreConseil from "../../../Images/Actualites/Afficher_Cadre_Conseil_Minimum30min.png";

export default function Actualites() {
  return (
    <div className={MonStyle.Actualite}>
      <div className={MonStyle.Liens}>
        <a
          className={MonStyle.Lien}
          href="https://shop.sinobi.fr"
          target="_blank"
          rel="noreferrer"
        >
          Découvrir Sinobi
        </a>
        <a
          className={MonStyle.Lien}
          href="https://shop.sinobi.fr/support"
          target="_blank"
          rel="noreferrer"
        >
          Support
        </a>
        <a
          className={MonStyle.Lien}
          href="https://shop.sinobi.fr/tarif"
          target="_blank"
          rel="noreferrer"
        >
          Tarifs
        </a>
        <a
          className={MonStyle.Lien}
          href="https://shop.sinobi.fr/contact"
          target="_blank"
          rel="noreferrer"
        >
          Nous contacter
        </a>
      </div>
      <section className={MonStyle.Article}>
        <h1>Fiches conseil, journal des factures et frais de port</h1>
        <p>Mise à jour du 3 octobre 2026</p>
        <h3>Choisissez les conseils de prise à imprimer</h3>
        <p>
          Dans une fiche conseil, vous pouvez désormais choisir de faire apparaître
          ou non le cadre « Minimum 30 minutes avant les repas avec de l'eau »
          et les indications de température sur le document imprimé.
        </p>
        <p>
          Pour masquer ce cadre dans le PDF, décochez la case « Afficher ce conseil
          de prise sur la fiche imprimée », située juste en dessous. Les autres
          éléments de la fiche restent présents et vos indications de prise
          restent disponibles à l'écran.
        </p>
        <p>
          La case est cochée par défaut à chaque ouverture de la fiche.
        </p>
        <a
          href={IllustrationCadreConseil}
          target="_blank"
          rel="noreferrer"
          style={{ display: "block", width: "100%" }}
        >
          <img
            src={IllustrationCadreConseil}
            alt="Case à décocher sous le cadre des conseils de prise pour le masquer à l'impression"
            className={MonStyle.Illustration}
          />
        </a>
        <p>Cliquez sur la capture pour l'agrandir.</p>
        <h3>Les périodes récentes en premier dans le journal des factures</h3>
        <p>
          Dans « Suivi des règlements », puis « Journal des factures », le mois
          courant reste en tête de liste. Les autres périodes sont maintenant
          classées de la plus récente à la plus ancienne, pour retrouver plus
          facilement vos dernières factures.
        </p>
        <h3>Frais de port internationaux : Herbier Naturel</h3>
        <p>
          Le calcul des frais de port des bons de commande Herbier Naturel a été
          corrigé pour les livraisons à l'étranger : un forfait de 12 € s'applique
          jusqu'à 250 € de produits inclus. Au-delà de 250 €, les frais de port
          sont offerts. Le barème des livraisons en France reste inchangé.
        </p>
      </section>
      <section className={MonStyle.Article}>
        <h1>Personnalisez vos emails de confirmation de rendez-vous</h1>
        <p>Nouvelle fonctionnalité — 3 octobre 2026</p>
        <p>
          Vous pouvez désormais ajouter un message destiné à votre patient dans
          l'email de confirmation de son rendez-vous : une recommandation, une
          consigne à suivre avant la consultation ou un lien vers son espace personnel.
        </p>
        <h3>Ajoutez votre message lors de la prise de rendez-vous</h3>
        <p>
          Dans l'agenda, sélectionnez le patient et activez la confirmation par
          email. Le champ « Texte personnalisé pour cet email » apparaît sous le
          choix de confirmation. Saisissez votre message, puis enregistrez le
          rendez-vous pour envoyer l'email.
        </p>
        <p>
          Vous disposez de 1 000 caractères, avec un compteur pour suivre la
          longueur de votre message. Vous pouvez écrire sur plusieurs lignes et
          ajouter un lien internet.
        </p>
        <img
          src={IllustrationRdvPersonnalise}
          alt="Saisie d'un message personnalisé sous la confirmation par email du rendez-vous"
          className={MonStyle.Illustration}
          style={{ maxWidth: "520px", alignSelf: "center" }}
        />
        <h3>Le patient retrouve votre message dans son email</h3>
        <p>
          Votre message s'ajoute au texte habituel de confirmation, avec ses
          retours à la ligne. Le patient reçoit ainsi les informations de son
          rendez-vous et vos indications dans le même email.
        </p>
        <img
          src={IllustrationRdvPersonnaliseEmail}
          alt="Email de confirmation reçu avec le message personnalisé et un lien internet"
          className={MonStyle.Illustration}
        />
        <p>
          Ce texte est utilisé uniquement pour cet envoi : il n'est pas repris
          automatiquement dans les prochains emails et ne modifie pas le message
          général de votre agenda. Si vous laissez le champ vide, la confirmation
          habituelle est envoyée.
        </p>
      </section>
      <section className={MonStyle.Article}>
        <h1>Mise à jour de la génération des Pdfs pour Chrome</h1>
        <p>
          Correction d'un bug introduit par une mise à jour de Chrome empêchant l'impression des fichiers PDF directement depuis l'aperçu.
        </p>
        <p>Ajout de l'adresse email du patient dans les bons de commande.</p>
      </section>
      <section className={MonStyle.Article}>
        <h1>Le module de paiement se renforce !</h1>
        <p>
          Correction d'un bug assez rare lors duquel le paiement automatisé mensuel... ne fonctionne tout simplement pas à cause d'une erreur d'arrondi de TVA.
        </p>
        <p>Mise à jour diverses quant aux nouvelles normes de données de paiement.</p>
        <p>A venir : possibilité de payer de façon tout à fait autonome en cas de bug nocturne dû aux cartes bancaires full 3D Secure.</p>
        <p>SINOBI ne sera pas disponible dimanche 18 janvier de minuit à midi.</p>
      </section>
      <section className={MonStyle.Article}>
        <h1>Mise à jour de la génération des Pdfs</h1>
        <p>
          Suite à une mise à jour majeure côté navigateurs, toute la génération de documents pdf à été revue et corrigée.
        </p>
        <p>Il est aussi maintenant possible dans la section rgpd d'avoir une version imprimable propre pour l'affichage dans le cabinet afin d'informer les patients.</p>
        <p>Les volets imprimables pour l'autocertification caisse sécurisée sont de retour, maintenant que la loi mettant fin à l'autocertification a été abrogée.</p>
      </section>

      <section className={MonStyle.Article}>
        <h1>Le consentement !</h1>
        <p>
          Un nouveau de type de document est disponible : le consentement.
        </p>
        <p>
          Il est souvent utile de recueillir et stocker un acte de consentement signé de la main du patient. Lorsque pour un patient vous aurez stocké un tel document, Sinobi vous le fera savoir en un clin d'oeil !
        </p>
        <img
          src={IllustrationConsentement}
          alt="Site sinobi"
          className={MonStyle.Illustration}
        />
      </section>

      <section className={MonStyle.Article}>
        <h1>Redesign des allergies et antécédents</h1>
        <p>
          Il est maintenant possible de choisir la couleur pour les allergies et
          antécédents quand ils sont importants. Nous avons profité de l'occasion
          pour améliorer la saisie des antécédents et allergies.
        </p>
        <p>
          De la même manière, ils sont regroupé par type (allergie, antécédent,
          antécédent familial...) dans la synthèse patient.
        </p>
        <img
          src={IllustrationAllergies}
          alt="Site sinobi"
          className={MonStyle.Illustration}
        />
      </section>

      <section>
        <a
          href="https://shop.sinobi.fr/support/ajouter-type-consultation"
          target="_blank"
          rel="noreferrer"
          className={MonStyle.Article}
        >
          {" "}
          <h1>Gestion des types de consultations</h1>
          <p>
            Il est maintenant possible de choisir comment afficher les
            consultations dans Sinobi. Pour chaque type de consultation vous
            pouvez choisir entre une consultation Energétique, une consultation
            de Santé ou Générique (saisie du motif et de texte)
          </p>
          <BoutonTexte>En savoir plus</BoutonTexte>
          <img
            src={IllustrationNouveauTypeConsultation4}
            alt="Site sinobi"
            className={MonStyle.Illustration}
          />
        </a>
      </section>

      <section>
        <a
          href="https://shop.sinobi.fr/support/afficher-consultation-archive"
          target="_blank"
          rel="noreferrer"
          className={MonStyle.Article}
        >
          <h1>Affichage des consultations archivées</h1>
          <p>
            Il est maintenant possible d'afficher les consultations archivées
            grâce un filtre dans l'historique des consultations. Il est même
            possible d'annuler l'archivage d'une consultation en cas d'erreur.
          </p>
          <BoutonTexte>En savoir plus</BoutonTexte>
          <img
            src={IllustrationConsultationArchive}
            alt="Site sinobi"
            className={MonStyle.Illustration}
          />
        </a>
      </section>

      <section>
        <a
          href="https://shop.sinobi.fr"
          target="_blank"
          rel="noreferrer"
          className={MonStyle.Article}
        >
          <h1>Site web Sinobi</h1>
          <h4>Ca y est le site officiel de Sinobi est en ligne!</h4>
          <h3>shop.sinobi.fr</h3>
          <img
            src={IllustrationSite}
            alt="Site sinobi"
            className={MonStyle.Illustration}
          />
        </a>
      </section>
    </div>
  );
}
